
import html2canvas from "html2canvas";
import { defineComponent, ref, watch } from "vue";
import { useRoute } from 'vue-router'
const route = useRoute()

// 给组件增加属性 posterData
export default defineComponent({
  name: 'Poster',
  props: {
    data: {
      type: Object,
      required: true
    },
    theme: {
      type: Object,
      required: false,
      default: () => ({
        headerBg: require('@/assets/images/header.png'),
        footerBg: require('@/assets/images/footer.png'),
        headerColor: '#FFFFFF',
        headerTextShadow: '0px 2px 3px rgba(116,99,39,0.6)',
        tableTitleBg: '#E65700',
        tableTitleFontSize: '26px',
        tableTitleColor: '#FFFFFF',
        tableBodyBg: '#C8171C',
        tableItemHeight: '72px',
        tableItemFontSize: '23px',
        colorGrey: '#F7F7F7',
        colorWhite: '#FFFFFF',
        lineFontSize: '20px',
        lineColor: '#FFFFFF'
      })
    }
  },
  setup(props, { emit }) {
    const currentData = ref(props.data)
    const theme = ref(props.theme)
    watch(
      () => props.theme,
      (newValue) => {
        theme.value = newValue
      }
    )
    const dynamicStyles = (theme: any) => {
      const styles = {
        '--header-bg': `url(${theme.headerBg})`,
        '--footer-bg': `url(${theme.footerBg})`,
        '--header-color': theme.headerColor,
        '--header-text-shadow': theme.headerTextShadow,
        '--table-title-bg': theme.tableTitleBg,
        '--table-title-font-size': theme.tableTitleFontSize,
        '--table-title-color': theme.tableTitleColor,
        '--table-body-bg': theme.tableBodyBg,
        '--table-item-height': theme.tableItemHeight,
        '--table-item-font-size': theme.tableItemFontSize,
        '--color-grey': theme.colorGrey,
        '--color-white': theme.colorWhite,
        '--line-font-size': theme.lineFontSize,
        '--line-color': theme.lineColor
      }
      return styles
    }

    const generateImage = async () => {
      const element = document.getElementById('generateArea');
      if (!element) {
        console.error('Element not found');
        return;
      }

      try {
        // 使用 html2canvas 将 DOM 元素转换为 canvas
        const canvas = await html2canvas(element);

        // 将 canvas 转换为图像数据 URL
        const dataURL = canvas.toDataURL('image/png');

        // 创建一个隐藏的 <a> 标签用于下载
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${currentData.value.title}.png`; // 设置下载文件名

        // 触发点击事件以开始下载
        link.click();

        // 清除资源
        link.remove();
      } catch (error) {
        console.error('Error capturing and downloading the image:', error);
      }
    }

    return {
      currentData,
      theme,
      dynamicStyles,
      generateImage
    }
  }
})
